import Api from '@/api/index';

const Supplier = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    oneBrand: null,
    all_brands: null,
    oneProduct: null,
    all_products: null,
    oneMarket: null,
    allMarkets: null,
    onePrice: null,
    allPrices: null,
    onePPL: null,

    oneSupplier: null,

    errorMessage: null,
    errorActive: null,

    updateGood: null,
    updateMessage: null,
  },
  mutations: {
    getSuppliers(state, {suppliers, type}){
      if (type == 'brands') {
        state.all_brands = suppliers.data;
      } else if (type == 'products') {
        state.all_products = suppliers.data;        
      } else if (type == 'pickup_locations') {
        state.allMarkets = suppliers;
      } else if (type == 'product_prices') {
        state.allPrices = suppliers.data;
      } 
    },
    setAllProducts(state, products) {
      state.all_products = products;
    },
    pushSupplier(state, {supplier, type}){
      if (type == 1) {
        state.all_brands.push(supplier)
      } else if (type == 2) {
        state.all_products.push(supplier)        
      } else if (type == 3) {
        state.allMarkets.push(supplier)
      } else if (type == 4) {
        state.allPrices.push(supplier)
      }
    },
    getOneSupplier(state, {supplier, type}){
      if (type == 'brands') {
        state.oneBrand = supplier.data;
      } else if (type == 'products') {
        state.oneProduct = supplier.data;        
      } else if (type == 'pickup_locations') {
        state.oneMarket = supplier.data;
      } else if (type == 'product_prices') {
        state.onePrice = supplier.data;
      } else if (type == 'product_pickup_locations'){
        state.onePPL = supplier
      }

      state.oneSupplier = supplier
    },

    getOnePL(state, {supplier, type}){    
      if (type == 'pickup_locations') {
        state.oneMarket = supplier.data;
      }
    },

    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
      setTimeout(() => {
        state.errorMessage = null
        state.errorActive = null  
      }, 250);
    },

    wasUpdateGood(state, {message, status}){
      state.updateGood = status
      state.updateMessage = message
      setTimeout(() => {
        state.updateGood = null
        state.updateMessage = null  
      }, 250);
    },

    clearOneSupplier(state){
      state.oneSupplier = null
    },
    clearAllSuppliers(state, type){
      if (type == 'brands') {
        state.all_brands = null;
      } else if (type == 'products') {
        state.all_products = null;        
      } else if (type == 'pickup_locations') {
        state.allMarkets = null
      } else if (type == 'product_prices') {
        state.allPrices = null;
      } 
    },
  },
  actions: {
    index(context, type){
      return Api.Supplier.index(type)
        .then(response => response.data)
        .then(suppliers => {
          context.commit('getSuppliers', {suppliers: suppliers ,type: type});
          // context.commit('setErrorMessage', {message: '',status: false});
          return suppliers
        }).catch(function(error) {
          console.log('erro no index');
          console.log(error);
        });
    },
    // Update only products
      updateOnlyProduct(context, {id, product}){
        return Api.Supplier.updateOnlyProduct(id, product)
          .then(response => response.data)
          .then(supplier1 => {
            context.commit('wasUpdateGood', {message: '',status: true});
            context.commit('getOneSupplier', {supplier: supplier1 ,type: 'products'});
        }).catch(function(error) {
            // console.log('error in update: '+ type);
            // console.log(error);
            context.commit('wasUpdateGood', {message: error.response.data.errors[0], status: false});
            throw Error(error.response.data.errors[0])
          });
      },

    clearOneSupplier(context){
      context.commit('clearOneSupplier')
    },

    clearAllSuppliers(context, type){
      context.commit('clearAllSuppliers', type);
    },


  }

};

export default Supplier;
